<template>
  <div class="post-webwidget-v2-now-playing-detail-wrapper">
    <div class="post-webwidget-v2-now-playing-detail-show-name">
      <div>{{ showTitle || (station ? station.toUpperCase() : '') }}</div>
    </div>
    <div class="post-webwidget-v2-now-playing-detail-episode-name">
      {{ episodeName }}&nbsp;
    </div>
    <div class="post-webwidget-v2-now-playing-detail-share-buttons">
      <div 
        v-show="episodeName"
        v-el:sharing
        class="addthis_inline_share_toolbox"
        :data-url="addThisUrl"
        :data-title="episodeName"
        :data-description="episodeDescription"
        :data-media="shareImage"
      ></div>
    </div>
    <div class="post-webwidget-v2-now-playing-detail-audio-player">
      <viblast-audio-player
        :dark-theme="darkTheme"
        :autoplay="episodeAutoPlay"
        :audio-file-src="episodeAudioFileSrc"
        :playing-live-stream="playingLiveStream"
        @pause="onAudioPause"
        @play="onAudioPlay"
        @ready="onViblastAudioPlayerReady"
        @episode-ended="$emit('episode-ended')"
      ></viblast-audio-player>
    </div>
  </div>
</template>

<script>
import addthis from '../addthis';
import ViblastAudioPlayer from './ViblastAudioPlayer';

export default {
  name: 'now-playing-detail',
  components: {
    ViblastAudioPlayer,
  },
  props: {
    darkTheme: Boolean,
    showTitle: String,
    station: String,
    episodeName: String,
    episodeDescription: String,
    episodeAudioFileSrc: String,
    playingLiveStream: Boolean,
    episodeAutoPlay: {
      type: Boolean,
      default: false, // 0 instead of false because Chrome doesn't understand false
    },
  },
  computed: {
    shareUrl() {
      return addthis.url(this.episodeName, this.station);
    },
  },
  methods: {
    emitAudioPlayerAction(action) {
      this.$emit(`audio:${action}`);
    },
    onAudioPause() {
      this.emitAudioPlayerAction('pause');
    },
    onAudioPlay() {
      this.emitAudioPlayerAction('play');
    },
    onViblastAudioPlayerReady(audioPlayerRef) {
      this.$emit('audio-player:ready', audioPlayerRef);
    },
  },
};
</script>

<style lang="scss" scoped>
.post-webwidget-v2-now-playing-detail-wrapper {
  margin: 1em;

  .post-webwidget-v2-now-playing-detail {
    &-show-name {
      margin-bottom: 0.5em;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &-episode-name {
      font-size: 1.2em;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &-share-buttons {
      display: inline-flex;
      justify-content: space-between;
      margin: 1em 0 0 0;
      height: 50px;
    }

    &-audio-player {
      //
    }
  }
}
</style>



// WEBPACK FOOTER //
// NowPlayingDetail.vue?031c134f